import { getDefaultDevicePlayerMap } from '../../propositions/default-device-player-map';
import { getDevicePlayerMap } from '../../propositions/proposition-extensions';
/**
 * @public
 */ export function getCurrentPlayerType(proposition, deviceType, deviceInfo, override, nativeOverride) {
    if (override && !nativeOverride) {
        // eslint-disable-next-line no-console -- This is testing code essentially
        console.log('%cDANGER!', 'color:red; font-size: 20px');
        // eslint-disable-next-line no-console -- This is testing code essentially
        console.log('%c>using player override %s', 'font-size: 15px', override);
        return override;
    }
    var defaultDevicePlayerMap = getDefaultDevicePlayerMap(deviceInfo);
    var devicePlayerMap = getDevicePlayerMap(proposition, deviceInfo, deviceType);
    var nativePlayer = devicePlayerMap[deviceType].native || defaultDevicePlayerMap[deviceType].default;
    return nativeOverride ? nativePlayer : devicePlayerMap[deviceType].default;
}

//# sourceMappingURL=player-recognition.js.map